// Use the site's existing analytics provider when configured.
// Analytics must never interrupt a successful contact request.
export function track(eventName, parameters = {}) {
  if (typeof window === 'undefined') return;
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, parameters);
    }
  } catch (_) {
    // Optional telemetry is non-blocking.
  }
}
